import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import aiProcessVisual from '../assets/ai-process-visual.webp';
import nfpMission from '../assets/nfp-mission.webp';
import deliveryProcess from '../assets/delivery-process.webp';

export function AboutPage() {
  return (
    <>
      <Header />
      <main className="about-page">
        <div className="about-grid">
          {/* Top Left: Award Card */}
          <section className="about-card award-section">
            <div className="award-content">
              <div className="award-text">
                <h2>Award-Recognized AI Architecture</h2>
                <ul className="about-list">
                  <li>We specialise in engineering transformative generative AI solutions tailored specifically for the care and not-for-profit sectors.</li>
                  <li>Our proven architectural track record includes designing and developing the end-to-end generative AI architecture and data analytics for an enterprise application recognized globally as the 2025 APAC Runner-Up for Gartner's Midsize Enterprise Innovation Award and named a finalist for the 2026 ITAC Awards.</li>
                  <li>We do not recycle past solutions; we apply this proven, high-level technical methodology to solve your unique operational challenges, ensuring your data remains secure and your intellectual property remains entirely yours.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Top Right: AI Illustration */}
          <section className="about-card visual-only">
            <img src={aiProcessVisual} alt="AI Brain and Cloud Illustration" className="responsive-img" />
          </section>

          {/* Bottom Left: Purpose Card */}
          <section className="about-card purpose-section">
            <h2>Driven by Purpose, Not Just Profit</h2>
            <div className="purpose-visual">
              <img src={nfpMission} alt="Giving back to NFP" className="responsive-img glow-effect" />
            </div>
            <p>At <strong>Sevnis</strong>, we believe in giving back to society. specifically partnering with Not-for-Profit organisations. Unlike some larger, profit-driven firms, we make it our core mission to prioritise impact and community empowerment over mere profitability.</p>
          </section>

          {/* Bottom Right: Efficiency Card */}
          <section className="about-card efficiency-section">
            <h2>Efficient Excellence Through AI</h2>
            <div className="efficiency-visual">
              <img src={deliveryProcess} alt="AI Delivery Process Flow" className="responsive-img" />
            </div>
            <p>We extensively use <strong>AI at every step of our delivery process</strong> — from strategic insight to launch — to dramatically reduce our operational costs. We pass these savings directly to you, enabling us to deliver truly world-class solutions within a budget that works for your organization.</p>
          </section>
        </div>
      </main>
      <Footer isAboutPage={true} />
    </>
  );
}
